import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { FiLock } from 'react-icons/fi';
import { useParams, useNavigate } from 'react-router-dom';

import logo from 'assets/logo.png';

import {
  checkTokenRequest,
  resetPasswordRequest,
} from 'store/modules/resetpassword/actions';

/* Componente */
import Button from 'components/Button';
import Input from 'components/Input';
import MessageBox from 'components/MessageBox';

/* Estilização */
import { Container } from './styles';

const schema = Yup.object().shape({
  token: Yup.string().required('A Chave é obrigatória'),
});

const schemaReset = Yup.object().shape({
  senha: Yup.string()
    .min(6, 'A senha precisa de 6 caracteres')
    .required('A Senha é obrigatória'),
  confirma: Yup.string()
    .oneOf([Yup.ref('senha')], 'As senhas não conferem')
    .required('A Senha é obrigatória'),
});

export default function ForgotPassword({ match }) {
  // react-router-dom
  const navigate = useNavigate();
  const { resettoken } = useParams();

  const dispatch = useDispatch();
  const resetpassword = useSelector(state => state.resetpassword);
  const formRefToken = useRef(null);
  const formRefReset = useRef(null);
  // pega parametros
  const [token, setToken] = useState();
  useEffect(() => {
    setToken(resettoken || resetpassword.token);
  }, [resettoken, resetpassword.token]);

  const handleCheckToken = useCallback(
    async ({ token }) => {
      try {
        formRefToken.current.setErrors({});
        await schema.validate({ token }, { abortEarly: false });
        dispatch(checkTokenRequest(token));
      } catch (err) {
        const validationErrors = {};
        if (err instanceof Yup.ValidationError) {
          err.inner.forEach(error => {
            validationErrors[error.path] = error.message;
          });
          formRefToken.current.setErrors(validationErrors);
        }
      }
    },
    [dispatch],
  );

  const handleResetSenha = useCallback(
    async ({ senha, confirma }) => {
      try {
        formRefReset.current.setErrors({});
        await schemaReset.validate({ senha, confirma }, { abortEarly: false });
        dispatch(resetPasswordRequest(senha, confirma, resettoken));
        navigate('/');
      } catch (err) {
        const validationErrors = {};
        if (err instanceof Yup.ValidationError) {
          err.inner.forEach(error => {
            validationErrors[error.path] = error.message;
          });
          formRefReset.current.setErrors(validationErrors);
        }
      }
      dispatch(resetPasswordRequest(senha, confirma, resettoken));
    },
    [dispatch, resettoken],
  );

  return (
    <Container>
      <img src={logo} alt="RPC" />
      {token ? (
        <Form ref={formRefReset} onSubmit={handleResetSenha} autoComplete="off">
          {!!resetpassword.error && (
            <>
              <MessageBox type="error">{resetpassword.error}</MessageBox>
              <Button
                color="primary"
                onClick={() => navigate('/esqueceusenha')}
              >
                SOLICITAR NOVA CHAVE
              </Button>
            </>
          )}
          {!resetpassword.error && (
            <>
              <Input
                name="senha"
                type="password"
                placeholder="Nova Senha"
                max={15}
                icon={<FiLock />}
              />
              <Input
                name="confirma"
                type="password"
                placeholder="Confirma nova senha"
                max={15}
                icon={<FiLock />}
              />
              <Button
                fill="false"
                color="primary"
                type="submit"
                disabled={resetpassword.loading}
              >
                {resetpassword.loading ? 'AGUARDE ...' : ' ALTERAR E ENTRAR '}
              </Button>
            </>
          )}
          <Button fill color="primary" onClick={() => navigate('/')}>
            VOLTAR PARA LOGIN
          </Button>
        </Form>
      ) : (
        <Form ref={formRefToken} onSubmit={handleCheckToken} autoComplete="off">
          <h5>Informe a chave que você recebeu no email:</h5>

          <Input
            aria-label="token"
            name="token"
            type="text"
            placeholder="Chave"
            errorField={resetpassword.error}
            icon={<FiLock />}
          />
          {resetpassword.loading}
          <Button
            type="submit"
            fill="false"
            color="primary"
            disabled={resetpassword.loading}
          >
            {resetpassword.loading ? 'VALIDANDO' : ' VALIDAR CHAVE'}
          </Button>

          <Button fill color="primary" onClick={() => navigate('/')}>
            VOLTAR PARA LOGIN
          </Button>
        </Form>
      )}
    </Container>
  );
}

ForgotPassword.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      token: PropTypes.string,
    }),
  }),
};
